import { useContext } from "react"
import FeaturedExtras from "components/car/FeaturedExtras"
import ExtrasList from "components/car/ExtrasList"
import { CarContext } from "../CarContext"

export default function Extras() {
  const { car, page } = useContext(CarContext)
  const { extrasList, featuredExtras = [], technology, comfort, security, outside } = car

  return (
    <>
      {featuredExtras.length > 0 && <FeaturedExtras list={featuredExtras} page={page} />}
      <ExtrasList list={technology} title="technology" page={page} />
      <ExtrasList list={comfort} title="comfort" page={page} />
      <ExtrasList list={security} title="security" page={page} />
      <ExtrasList list={outside} title="outside" page={page} />
      <ExtrasList list={extrasList} title="packages" page={page} />
    </>
  )
}
